import { view, cssGenerator } from '@yola/ws-sdk';
import truncateToOneDecimal from './truncate-to-one-decimal';
import getCustomLineHeight from './get-custom-line-height';

const { MARGIN_TOP, MARGIN_BOTTOM } = cssGenerator.constants.attributes;

const parseLineHeightFromPxToEm = (value, fontSize) => {
  if (!value) return null;

  const numericValue = parseFloat(value);

  if (value.trim().endsWith('px')) {
    return numericValue / fontSize;
  }

  return numericValue;
};

const getLineHeight = (element, computedStyle, breakpoint) => {
  const fontSize = parseFloat(computedStyle.fontSize) || 1;

  const customLineHeight = getCustomLineHeight(element, breakpoint);

  if (customLineHeight !== null) {
    return parseFloat(customLineHeight);
  }

  const computedLineHeight = computedStyle.lineHeight;

  if (computedLineHeight === 'normal') {
    return 1;
  }

  const parsedComputedValue = parseLineHeightFromPxToEm(computedLineHeight, fontSize);
  return parsedComputedValue !== null ? truncateToOneDecimal(parsedComputedValue) : 1;
};

const getMarginValue = (element, computedStyle, attribute, computedProperty) => {
  const attrValue = element.getAttribute(attribute);
  return attrValue ? parseFloat(attrValue) : parseFloat(computedStyle[computedProperty]) || 0;
};

const getElementSpacingValues = (element, breakpoint) => {
  if (!element) return null;

  const liveDocument = view.accessors.getLiveDocument();
  const computedStyle = liveDocument.defaultView.getComputedStyle(element);

  return {
    lineHeight: getLineHeight(element, computedStyle, breakpoint),
    marginTop: getMarginValue(element, computedStyle, MARGIN_TOP, 'marginTop'),
    marginBottom: getMarginValue(element, computedStyle, MARGIN_BOTTOM, 'marginBottom'),
  };
};

export default getElementSpacingValues;
